import axios from 'axios';
import {
  getSessionToken
} from '@shopify/app-bridge-utils';

export default {
  install(Vue) {

    const instance = axios.create();
    instance.interceptors.request.use(
      function(config) {
        return getSessionToken(Vue.shopifyAppBridge)
          .then((token) => {
            config.headers['Authorization'] = `Bearer ${token}`;
            return config;
          });
      }
    );

    Vue.axios = instance;
  }
}
